import React, { PropsWithChildren, useState } from "react";
import { Popover, ArrowContainer } from "react-tiny-popover";
import styles from "./ToolTip.module.scss";

type TooltipProps = {
  content: React.ReactNode;
  placement?: "left" | "right" | "top" | "bottom";
};

export default function Tooltip({
  children,
  content,
  placement = "right",
}: PropsWithChildren<TooltipProps>) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      isOpen={isOpen}
      positions={[placement]} // where to show
      padding={10} // gap between trigger and panel
      onClickOutside={() => setIsOpen(false)}
      containerStyle={{ zIndex: "9999" }}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowSize={14} // inner arrow, smaller
          arrowColor="#fff" // panel background
          arrowStyle={{ zIndex: 999, left: "2px" }}
        >
          <div className={styles.panel}>{content}</div>
        </ArrowContainer>
      )}
    >
      <div
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {children}
      </div>
    </Popover>
  );
}
